import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FeedbackHoldComponent } from './feedback-hold.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		GoMaterialModule
	],
	declarations: [
		FeedbackHoldComponent
	],
	exports: [
		FeedbackHoldComponent
	]
})
export class FeedbackHoldModule {}
